import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { RoutesEnum, StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
import { Alert } from "~/components-shared";
import topicTargetSchema from "~/forms/TopicTargetForm/topicTargetSchema";
import TopicTargetForm from "~/forms/TopicTargetForm";
import { TopicActionEnum } from "~/store/topics/types";
import { splitHours } from "~/lib/helpers";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const TopicTargetUpdateModal = () => {
  const {
    t
  } = useTranslation();
  const topic = useSelector(topicSelectors.getSelected);
  const target = useSelector(topicSelectors.getSelectedData);
  const action = useSelector(topicSelectors.getAction);
  const status = useSelector(topicSelectors.getTargetStatus);
  const error = useSelector(topicSelectors.getTargetError);
  const history = useHistory();
  const dispatch = useDispatch();
  const defaultValues = {
    name: target?.name || "",
    description: target?.description || "",
    color: target?.color || "",
    memberIds: target?.members?.map(member => member.id) || [],
    sources: target?.sources || [],
    durationDays: splitHours(target?.duration || 0).days,
    durationHours: splitHours(target?.duration || 0).hours
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    resolver: yupResolver(topicTargetSchema),
    defaultValues
  });
  useEffect(() => {
    if (action === TopicActionEnum.UPDATE_TARGET) {
      reset(defaultValues);
    }
  }, [action]);
  const handleClose = () => {
    dispatch(topicActionCreators.actionChanged(null, null));
  };
  const onSubmit = handleSubmit(data => {
    if (topic?.id && target?.id) {
      data.duration = data.durationDays * 24 + data.durationHours;
      dispatch(topicActionCreators.updateTargetStarted(topic.id, target.id, data, _ref => {
        let {
          data: newTarget
        } = _ref;
        if (newTarget) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TopicUpdateModal.topicUpdated", {
              name: newTarget.name
            }),
            timeout: 10000,
            actions: [{
              icon: "external-link",
              onClick: () => history.push(RoutesEnum.TOPIC.replace(":topicId", newTarget.id))
            }]
          }));
        }
      }));
    }
  });
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicTargetUpdateModal.updateTarget"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true,
    isSticky: true
  }, error), /*#__PURE__*/React.createElement(TopicTargetForm, {
    control: control,
    topic: topic,
    target: target
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicTargetUpdateModal.saveTarget")))));
};
export default TopicTargetUpdateModal;